/* eslint-disable no-console */
import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import API from '@aws-amplify/api';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import LoaderButton from '../LoaderButton';
import Feedback from '../Feedback';
import DeviceContext from '../../context/DeviceContext';

const useStyles = makeStyles((theme) => ({
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  datePicker: {
    marginTop: 0,
    width: '100%',
  },
  switchWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    // fontWeight: 600,
  },
  cardActions: {
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(2),
  },
}));

export default function Messbericht() {
  const classes = useStyles();
  const { fetchDevices, currentDevice, setCurrentDevice } = useContext(DeviceContext);
  const active = currentDevice.serialNumber !== undefined;
  const [date, setDate] = useState<Date | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  // const [activated, setActivated] = useState(false);

  async function handleSubmit() {
    try {
      setLoading(true);
      setError(false);
      setSuccess(false);
      const timestamp = date ? Math.round(date.getTime() / 1000) : undefined;
      await API.post('emilog', 'updateMessbericht', {
        body: {
          serialNumber: currentDevice.serialNumber,
          timestamp: timestamp ?? null,
        },
      });
      setCurrentDevice((prevState: Device) => ({
        ...prevState,
        Messbericht_bis: Number.isNaN(timestamp) ? undefined : timestamp,
      }));
      fetchDevices();
      setSuccess(true);
      setLoading(false);
    } catch (err) {
      setError(true);
      setLoading(false);
      console.log(err);
    }
  }

  useEffect(() => {
    setSuccess(false);
    setError(false);
    if (typeof currentDevice?.Messbericht_bis !== 'undefined') {
      const endDate = new Date(currentDevice.Messbericht_bis * 1000);
      setDate(endDate as Date);
    } else {
      setDate(null);
    }
  }, [currentDevice]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>

      <Card>
        <CardHeader
          title="Digitaler Messbericht"
        />
        <Divider />
        <CardContent className={classes.cardContent}>
          <KeyboardDatePicker
            value={date}
            className={classes.datePicker}
            disabled={!active}
            disableToolbar
            autoOk
            minDate={new Date()}
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            id="date-picker-inline"
            label="Ablaufdatum"
            onChange={(e) => setDate(e)}
            invalidDateMessage="Kein korrektes Format"
            minDateMessage="Lizenz abgelaufen"
            inputVariant="outlined"
          />
          {/* <div className={classes.switchWrapper}>
            <Typography className={classes.label}>Aktiv</Typography>
            <Switch
              color="primary"
              checked={activated}
              // onChange={(event) => setActivated(event.target.checked)}
              disabled
            />
          </div> */}
        </CardContent>
        <Divider />
        <CardActions className={classes.cardActions}>
          <Feedback error={error} success={success} />
          <LoaderButton isLoading={loading} text="Absenden" onClick={handleSubmit} disabled={!active} />
        </CardActions>
      </Card>
    </MuiPickersUtilsProvider>
  );
}
